import { LogLevel, PublicClientApplication } from '@azure/msal-browser'

// CIAM B2C (Microsoft Entra External ID) app registration values.
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID
const authority = import.meta.env.VITE_AZURE_AUTHORITY
const redirectUri = import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin

if (!clientId || !authority) {
  console.error(
    'Missing MSAL configuration. Make sure VITE_AZURE_CLIENT_ID and VITE_AZURE_AUTHORITY ' +
    'are set (see .env.example).'
  )
}

export const msalConfig = {
  auth: {
    clientId,
    authority,
    knownAuthorities: [authority.replace(/^https*:\/\//, '').replace(/\/.+$/, '')],
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
    },
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)

// Scopes requested at login and used to acquire access tokens for the API.
// For CIAM this should be the scope(s) exposed by the API's app registration
// (e.g. "api://<api-client-id>/access_as_user"), not the app's own client ID
// like the classic B2C app did. Defaults to an ID-token-only login.
export const loginRequest = {
  scopes: (import.meta.env.VITE_AZURE_SCOPES || 'openid,profile')
    .split(',')
    .map((scope) => scope.trim())
    .filter(Boolean),
  // Show the hosted sign-in pages in Croatian regardless of browser or
  // account language, to match the rest of the UI.
  // External ID expects both parameters with a full locale code.
  extraQueryParameters: { ui_locales: 'hr-HR', mkt: 'hr-HR' },
}
